export default "__VITE_ASSET__93QbYETz__"